import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getEmployeeFeedbackSlice = createSlice({
  name: "getEmployeeFeedback",
  initialState,
  reducers: {
    setEmployeeFeedbackId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetEmployeeFeedbackId: (state) => {
      state.id = "";
    },
    getEmployeeFeedbackStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getEmployeeFeedbackSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getEmployeeFeedbackFailed: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    resetEmployeeFeedback: () => {
      return { ...initialState };
    },
  },
});

export const {
  setEmployeeFeedbackId,
  resetEmployeeFeedbackId,
  getEmployeeFeedbackStart,
  getEmployeeFeedbackSuccess,
  getEmployeeFeedbackFailed,
  resetEmployeeFeedback,
} = getEmployeeFeedbackSlice.actions;

export default getEmployeeFeedbackSlice.reducer;
